import React, { Component } from 'react'
import LoadingScreen from 'react-loading-screen'
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import logo from "assets/img/logo/logo_aig_login-2.png";
import Select1 from 'react-select';
import makeAnimated from 'react-select/lib/animated'
import { Card, CardBody, Row, Col, Button, Label, CardHeader, Alert } from "reactstrap";
import { Select, Textbox, Textarea } from "react-inputs-validation";
import { urlConsultarIdentificacion, urlCiudadesPorRamos } from '../../constants/urls'
import { apiPost,apiPost2 } from '../../api/index'
import { Ramos, empresa, EquiRamos, ErrorMsgConstants } from '../../constants'
import { isDuplicateHogar } from '../../redux/actions/ACarritoProductos';
const ramo = Ramos.rcandina

class Ubicacion extends Component {
    constructor(props) {
        super(props)

        const { provinciaSelected = '', ciudadSelected = '', direccion = '', sucursal = '', rucEmpresa = '', nomEmpresa = '', nombres = '', apellidos = '' } = this.props
        let hasProvinciaError = true
        let hasCiudadError = true
        if (provinciaSelected) {
            hasProvinciaError = false
            this.consultarCiudades(provinciaSelected.provCodigoCore)
        }
        if (ciudadSelected) hasCiudadError = false
        this.state = {
            validate: false,
            hasCiudadError,
            hasProvinciaError,
            hasDireccionError: true,
            hasSucursalError: true,
            hasNombreError: true,
            hasCedulaError: true,
            hasPersoneriaError: true,
            personeria: '',
            rucEmpresa, nomEmpresa,
            nombres, apellidos,
            sucursal,
            provinciaSelected, ciudadSelected, direccion,

        }
    }
    componentDidMount() {
        let { rucEmpresa = '', nomEmpresa = '', placa = '', sucursal = '', personeria = '' } = this.props
        this.setState({ rucEmpresa, nomEmpresa, placa, sucursal, personeria })
        setTimeout(() => this.setState({ validate: true }), 1000)
        window.scroll(0, 0)

    }
    consultaCargarDatos = async ({ rucEmpresa }) => {
        let tipo = 'cedula'
        if (rucEmpresa.length === 13) tipo = 'ruc'
        const param = { tipo, leerCache: true, identificador: rucEmpresa }
        const data = await apiPost2(urlConsultarIdentificacion, param)

        if (data.transaccion) {
            let { nombre, nombres, apellidos } = data.datosIdentificador[0]
            let nomEmpresa = ''
            if (rucEmpresa.length === 13) {
                nomEmpresa = nombre
                nombres = ''
                apellidos = ''
            }
            this.setState({ nomEmpresa, nombres, apellidos, loading: false })
            setTimeout(() => this.setState({ validate: true }), 2000)
        } else {
            this.setState({ nomEmpresa: '', nombres: '', apellidos: '', loading: false })
        }
    }

    consultarCiudades = async (codProvincia) => {
        let data = { empresa, codProvincia, ramo }

        data = await apiPost(urlCiudadesPorRamos, data)
        const { transaccion, ciudades } = data
        if (transaccion)
            this.setState({ ciudades })
        else {
            this.setState({ error: 'No se pudo consultar', provinciaSelected: '', hasProvinciaError: true })
            setTimeout(() => this.setState({ error: '' }), 3000)
        }
    }
    validate = (validate) => {
        this.setState({ validate })
    }
    onClick = async() => {
        this.validate(true);
        const {
            hasCiudadError,
            hasProvinciaError,
            hasDireccionError,
            hasSucursalError,
            hasNombresError,
            hasNombreError,
            hasApellidosError,
            sucursal,
            nombres, apellidos,
            rucEmpresa, nomEmpresa, personeria,
            provinciaSelected: provincia, ciudadSelected: ciudad, direccion
        } = this.state

        // Llamar al servicio de validación de duplicidad de poliza
        const checkDuplicidadObj = {
            empresa: "AIGMETROPOLITANA",        
            plataforma: 'WEB',
            identificacion: rucEmpresa,
            ramo: EquiRamos.rcAndina,
        };
        console.log('checkDuplicidadObj pymes', checkDuplicidadObj, );
        await this.props.checkIsDuplicate({type:'otros', postObj:checkDuplicidadObj});

        // si es que no existe duplicidad, continuar al siguiente paso
        if (!this.props.duplicity.isDuplicatePoliza){
            // continuar si no hubo errores
            if (!hasCiudadError && !hasProvinciaError && !hasDireccionError && !hasSucursalError && !this.props.duplicity.duplicidadPolizaError && ((`${personeria}` !== '2' && !hasNombresError, !hasApellidosError) || (`${personeria}` === '2' && !hasNombreError))) {
                const paso = 0
                this.props.handleNext({ params: { provincia, ciudad, direccion, sucursal, rucEmpresa, nomEmpresa, personeria, nombres, apellidos }, paso });
            }
        }
    }
    render() {

        console.log('UbicacionP', this.props)
        console.log('UbicacionS', this.state)

        const { validate, loading,
            provinciaSelected,
            ciudadSelected,
            hasProvinciaError,
            hasCiudadError,
            ciudades,
            direccion,
            sucursal,
            rucEmpresa,
            nomEmpresa,
            personeria,
            nombres, apellidos
        } = this.state
        const { provincias, arrayPersoneria } = this.props
        const { arraySucursales } = this.props

        return (
            <LoadingScreen
                loading={loading || this.props.duplicity.duplicidadPolizaLoading}
                bgColor="#f1f1f1"
                spinnerColor="#001871"
                textColor="#676767"
                logoSrc={logo}
                text="Cargando..."
            >
                <Card >
                    <CardHeader> <h3 style={{ fontWeight: 'bold', }}> Datos del Cliente </h3></CardHeader>
                    <CardBody>

                        <Row className='mt-3'>
                            <Col sm={4}>
                                <h4><Label for="selectPersoneria" >Seleccione la personería </Label></h4>
                            </Col>
                            <Col sm={7} >
                                <Select
                                    id={"selectPersoneria"} // Optional.[String].Default: "". Input ID.
                                    name={"selectPersoneria"} // Optional.[String].Default: "". Input name.
                                    value={personeria} // Optional.[String].Default: "".
                                    optionList={arrayPersoneria} // Required.[Array of Object(s)].Default: [].
                                    onChange={(personeria, e) => this.setState({ personeria, hasPersoneriaError: !!personeria === '', nombres: '', apellidos: '', nomEmpresa, rucEmpresa: '' })}
                                    validate={validate}
                                    validationCallback={(res) => this.setState({ hasPersoneriaError: res, validate: false })
                                    }
                                    // Optional.[Func].Default: () => {}. Will return the value.
                                    onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                                    customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                                    validationOption={{
                                        name: "selectPersoneria", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                        check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                        required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                        msgOnError: "Por favor seleccione una personeria"
                                    }}
                                />
                            </Col>
                        </Row>

                        <Row className='mt-3'>
                            <Col sm={4} >
                                <h4 >Identificación (*)</h4>
                            </Col>
                            <Col sm={7} >
                                <Textbox
                                    type={personeria === '3' ? 'text' : 'number'}
                                    id="cedula"
                                    name="cedula"
                                    classNameInput={"form-control"}
                                    value={rucEmpresa}
                                    validate={validate}
                                    onChange={(rucEmpresa, e) => {
                                        this.setState({ rucEmpresa })
                                        if ((rucEmpresa.length === 13 && personeria === '2') || (rucEmpresa.length === 10 && personeria === '1')) {
                                            this.setState({ loading: true })
                                            this.consultaCargarDatos({ rucEmpresa })
                                        }
                                    }}
                                    onBlur={() => { }}
                                    validationCallback={res => this.setState({ hasCedulaError: res, validate: false })}
                                    validationOption={{
                                        name: "cedula", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                        check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                        required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                        reg: personeria === '1' ? /^\d{10}$/ : personeria === '2' ? /\d{13}$/ : /^[a-zA-Z0-9]*$/,
                                        msgOnError: `Por favor ingrese la identificación correctamente`
                                    }}
                                />
                            </Col>
                        </Row>
                        {personeria === '2' &&
                            <Row className='mt-3'>
                                <Col sm={4} >
                                    <h4> Razón Social (*)</h4>
                                </Col>
                                <Col sm={7} >
                                    <Textbox
                                        type="text"
                                        id="nombres"
                                        name="nombres"
                                        validate={validate}
                                        classNameInput={"form-control"}
                                        value={nomEmpresa}
                                        onChange={(nomEmpresa, e) => this.setState({ nomEmpresa })}
                                        onBlur={() => { }}
                                        validationCallback={hasNombreError => this.setState({ hasNombreError, validate: false })}
                                        validationOption={{
                                            name: "nombres", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                            // reg: /^[\u00e1\u00e9\u00ed\u00f3\u00fa\u00c1\u00c9\u00cd\u00d3\u00da\u00f1\u00d1A-Za-z _]*$/,
                                            required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                            msgOnError: "Por favor ingrese los nombres ó razón social"
                                        }}
                                    />
                                </Col>
                            </Row>}
                        {personeria !== '2' && <> <Row className='mt-3'>
                            <Col sm={4} >
                                <h4>Nombres (*)</h4>
                            </Col>
                            <Col sm={7} >
                                <Textbox
                                    type="text"
                                    id="nombres"
                                    name="nombres"
                                    validate={validate}
                                    classNameInput={"form-control"}
                                    value={nombres}
                                    onChange={(nombres, e) => this.setState({ nombres })}
                                    onBlur={() => { }}
                                    validationCallback={(hasNombresError) => this.setState({ hasNombresError, validate: false })}
                                    validationOption={{
                                        name: "nombres", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                        check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                        // reg: /^[\u00e1\u00e9\u00ed\u00f3\u00fa\u00c1\u00c9\u00cd\u00d3\u00da\u00f1\u00d1A-Za-z _]*$/,
                                        required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                        msgOnError: "Por favor ingrese los nombres"
                                    }}
                                />
                            </Col>
                        </Row>
                            <Row className='mt-3'>
                                <Col sm={4} >
                                    <h4>Apellidos (*)</h4>
                                </Col>
                                <Col sm={7} >
                                    <Textbox
                                        type="text"
                                        id="Apellidos"
                                        name="Apellidos"
                                        validate={validate}
                                        classNameInput={"form-control"}
                                        value={apellidos}
                                        onChange={(apellidos, e) => this.setState({ apellidos })}
                                        onBlur={() => { }}
                                        validationCallback={(hasApellidosError) => this.setState({ hasApellidosError, validate: false })}
                                        validationOption={{
                                            name: "Apellidos", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                            // reg: /^[\u00e1\u00e9\u00ed\u00f3\u00fa\u00c1\u00c9\u00cd\u00d3\u00da\u00f1\u00d1A-Za-z _]*$/,
                                            required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                            msgOnError: "Por favor ingrese los Apellidos"
                                        }}
                                    />
                                </Col>
                            </Row></>}

                    </CardBody>

                    <CardHeader> <h3 style={{ fontWeight: 'bold', }}> Ubicación </h3></CardHeader>
                    <CardBody>
                        <Row className="mb-3">
                            <Col sm={4}>
                                <h4>
                                    <Label >Provincia </Label>
                                </h4>
                            </Col>
                            <Col sm={7} >

                                <Select1
                                    value={provinciaSelected}
                                    components={makeAnimated()}
                                    onChange={(provinciaSelected, e) => {
                                        this.consultarCiudades(provinciaSelected.provCodigoCore)
                                        this.setState({
                                            provinciaSelected,
                                            ciudadSelected: '',
                                            hasProvinciaError: false,
                                            hasCiudadError: true,
                                        });
                                    }}
                                    options={provincias}
                                    isSearchable={true}
                                    placeholder={"Seleccione una provincia"}
                                    isMulti={false}
                                />
                                {hasProvinciaError &&
                                    <span className='react-inputs-validation__msg___pxv8o react-inputs-validation__error___2aXSp'>
                                        Por favor seleccione una provincia </span>
                                }
                            </Col>

                        </Row>

                        <Row className="mb-3">
                            <Col sm={4}>
                                <h4>
                                    <Label >Ciudad </Label>
                                </h4>
                            </Col>
                            <Col sm={7} >

                                <Select1
                                    value={ciudadSelected}
                                    components={makeAnimated()}
                                    onChange={(ciudad, e) => {
                                        this.setState({
                                            ciudadSelected: ciudad,
                                            hasCiudadError: false
                                        });
                                    }}
                                    options={ciudades}
                                    isSearchable={true}
                                    placeholder={"Seleccione una ciudad"}
                                    isMulti={false}
                                />

                                {hasCiudadError &&
                                    <span className='react-inputs-validation__msg___pxv8o react-inputs-validation__error___2aXSp'>
                                        Por favor seleccione una ciudad  </span>
                                }
                            </Col>

                        </Row>

                        <Row className="mb-3">
                            <Col sm={4}>
                                <h4>
                                    <Label >Dirección </Label>
                                </h4>
                            </Col>
                            <Col sm={7} >

                                <Textarea
                                    tabIndex="1"
                                    type="input"
                                    value={direccion}
                                    name="inDireccion"
                                    id="inDireccion"
                                    classNameInput={"form-control"}
                                    onChange={(direccion, e) => { console.log('poipo', direccion); this.setState({ direccion: direccion.toUpperCase(), hasDireccionError: false }) }}
                                    placeholder="Ingrese la dirección" // Optional.[String].Default: "".
                                    validate={validate}
                                    validationCallback={res => { console.log('poipo', res); this.setState({ hasDireccionError: res, validate: !res }) }} // Optional.[Func].Default: none. Return the validation result.
                                    onBlur={() => { }}
                                    validationOption={{
                                        name: 'inDirección', // Optional.[String].Default: "". To display in the Error message. i.e Please enter your {name}.
                                        check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                        required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                        msgOnError: "Debe ingresar una dirección." // Optional.[Bool].Default: true. To determin if it is a required field.
                                    }}
                                />
                            </Col>

                        </Row>

                    </CardBody>
                    <CardHeader> <h3 style={{ fontWeight: 'bold', }}> Sucursal de emisión </h3></CardHeader>
                    <CardBody>
                        <Row className='mt-3'>
                            <Col sm={4}>
                                <h4><Label for="SelectCiudad" >Surcursal </Label></h4>
                            </Col>
                            <Col sm={7} >
                                <Select
                                    id={"SelectCiudad"} // Optional.[String].Default: "". Input ID.
                                    name={"SelectCiudad"} // Optional.[String].Default: "". Input name.
                                    value={sucursal} // Optional.[String].Default: "".
                                    optionList={arraySucursales} // Required.[Array of Object(s)].Default: [].
                                    onChange={(sucursal, e) => this.setState({ sucursal, hasSucursalError: !!sucursal === '' })}
                                    validate={validate}
                                    validationCallback={(res) => this.setState({ hasSucursalError: res, validate: false })
                                    }
                                    // Optional.[Func].Default: () => {}. Will return the value.
                                    onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                                    customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                                    validationOption={{
                                        name: "SelectCiudad", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                        check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                        required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                        msgOnError: "Por favor seleccione una sucursal"
                                    }}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={11} className="mt-3" >

                                <Button className="btn btn-primary " style={{ display: 'block', margin: '0 0 0 auto', }} onClick={() => { this.setState({ validate: true }); this.onClick() }}>
                                    <i className="fa fa-chevron-circle-right" aria-hidden="true" />{` CONTINUAR`} {/* ${NumUbicacion} */}
                                </Button>
                            </Col>
                        </Row>
                        {/* Mensaje de error*/}
                        <div style={{ marginTop:'2rem'}}>
                            {/* Validacion de duplicidad */}
                            {console.log('test dup msg',  this.props.duplicity)}
                            {this.props.duplicity.isDuplicatePoliza
                            ?
                            <Alert color="danger">
                                <center><p>{ErrorMsgConstants.duplicidad}</p></center>
                            </Alert>
                            :
                            null
                            }
                            {this.props.duplicity.duplicidadPolizaError &&
                            <Alert color="danger" >
                                <center><p>{ErrorMsgConstants.errorServicioDuplicidad}</p></center>
                            </Alert>
                            }
                        </div>
                    </CardBody>
                </Card>
            </LoadingScreen>
        )
    }
}



const mapStateToProps = state => ({
    duplicity: state.datosDuplicidadPolizas,
  });
  
  const mapDispatchToProps = dispatch => {
    return {
      checkIsDuplicate: (datosCheckDuplicity) => dispatch(isDuplicateHogar(datosCheckDuplicity)),
    };
  };
  
  export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(Ubicacion)
  );
